import { Link } from "react-router-dom";
import { allWorks } from "@/mocks/works";
import { WORK_TYPE_LABEL } from "@/types/catalog";

const hotWorks = [...allWorks].sort((a, b) => b.views - a.views).slice(0, 6);

export default function HotSidebar() {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="flex items-center gap-2 text-base font-bold text-foreground-950">
          <i className="ri-fire-line text-accent-500"></i>
          热门推荐榜
        </h2>
        <span className="text-xs text-foreground-400">按热度排序</span>
      </div>

      <ul className="flex flex-col gap-3">
        {hotWorks.map((work, index) => (
          <li key={work.id}>
            <Link to={`/detail/${work.type}/${work.id}`} className="group flex cursor-pointer items-center gap-3">
              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                  index < 3 ? "bg-accent-500 text-background-50" : "bg-secondary-100 text-secondary-700"
                }`}
              >
                {index + 1}
              </span>
              <span className="h-16 w-12 shrink-0 overflow-hidden rounded-md bg-background-100">
                <img
                  src={work.cover}
                  alt={work.title}
                  title={`${work.title} - 爱妻艺热门推荐`}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                />
              </span>
              <span className="min-w-0 flex-1">
                <span className="line-clamp-1 text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
                  {work.title}
                </span>
                <span className="mt-1 block text-xs text-foreground-400">
                  {WORK_TYPE_LABEL[work.type]} · {work.year}
                </span>
                <span className="mt-1 flex items-center gap-1 text-xs text-accent-600">
                  <i className="ri-star-fill"></i>
                  {work.rating.toFixed(1)}
                  <span className="ml-1 text-foreground-400">热度 {work.views}</span>
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>

      <Link
        to="/category/movie"
        className="mt-4 flex cursor-pointer items-center justify-center gap-1 rounded-md bg-primary-50 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
      >
        查看完整榜单
        <i className="ri-arrow-right-s-line"></i>
      </Link>
    </section>
  );
}